import React from 'react';

const EventsWeddings = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-gray-800 mb-4 tracking-wide">
            WYDARZENIA / INCENTIVE / WESELA
          </h2>
          <div className="flex justify-center items-center gap-2 mb-6">
            {[...Array(4)].map((_, i) => (
              <i key={i} className="ri-star-fill text-black text-lg"></i>
            ))}
          </div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Świętuj swoje wydarzenia z nami
          </p>
        </div>

        {/* Intro Text */}
        <div className="max-w-4xl mx-auto text-center mb-20">
          <p className="text-base text-gray-700 leading-relaxed">
            La Gomera to jeden z najbardziej spektakularnych zakątków do organizacji wydarzeń na Wyspach Kanaryjskich. W Hotel Jardín Tecina jesteśmy przygotowani na organizację kongresów, spotkań, komunii, chrztów lub przygotowanie z Tobą dnia, który stanie się niezapomniany: Twojego wesela.
          </p>
        </div>

        {/* Nuestras Bodas */}
        <div className="mb-24">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <div className="w-full h-[400px] rounded-xl overflow-hidden shadow-lg">
                <img 
                  src="https://static.readdy.ai/image/2f500271175ac97b037b5e94d69334e6/6b39243eb43e5a9334f33fa01f2a31d2.jpeg"
                  alt="Elegancka dekoracja weselna z kwiatami"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="order-1 md:order-2">
              <h3 className="text-3xl font-light text-gray-800 mb-6 tracking-wide">
                NASZE WESELA
              </h3>
              <div className="space-y-4 text-base text-gray-700 leading-relaxed">
                <p>
                  Niezrównana lokalizacja, spersonalizowana obsługa, wymarzona dekoracja, wysokiej jakości gastronomia, to co najlepsze dla Twoich gości, spektakularny klimat i wszystko, czego pragniesz dla swojego wesela, czeka na Ciebie w Hotel Jardín Tecina.
                </p>
                <p className="font-medium">
                  Czy potrzebujesz czegoś więcej, aby uczcić jeden z najważniejszych dni w swoim życiu?
                </p>
                <p className="text-xl font-light text-gray-800 mt-6">
                  Powiedz TAK w Hotel Jardín Tecina!
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Reuniones, Congresos y Presentaciones */}
        <div className="mb-24">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <div className="w-full h-[400px] rounded-xl overflow-hidden shadow-lg">
                <img 
                  src="https://static.readdy.ai/image/2f500271175ac97b037b5e94d69334e6/a9ed00bf722cf7c7c67c84564b4fb207.jpeg"
                  alt="Sala konferencyjna z nowoczesnym wyposażeniem"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="order-1 md:order-2">
              <h3 className="text-3xl font-light text-gray-800 mb-6 tracking-wide">
                SPOTKANIA, KONGRESY I PREZENTACJE
              </h3>
              <div className="space-y-4 text-base text-gray-700 leading-relaxed">
                <p>
                  Hotel Jardín Tecina ma wszystko, czego potrzebujesz, aby Twoje wydarzenia lub spotkania odniosły sukces. Łączymy wypoczynek i pracę w tej samej przestrzeni, otoczonej bujnymi ogrodami i dźwiękami natury w tle. Idealne miejsce, gdzie oddycha się spokojem i ciszą.
                </p>
                <p>
                  Przyjemny klimat La Gomery pozwala na organizację profesjonalnych wydarzeń lub konwencji o każdej porze roku. Oferujemy wynajem sal na Wyspach Kanaryjskich, których potrzebujesz, aby z sukcesem zakończyć każde wydarzenie.
                </p>
                <p>
                  Sala Santiago to tylko przykład przestrzeni, które możemy Ci zaoferować: modułowe i dostosowane do liczby uczestników. Ta sala może pomieścić do 150 osób.
                </p>
                <p>
                  A ponieważ nie wszystko to praca... Czeka na Ciebie niezliczona ilość planów: trekking, trasy rowerowe, nurkowanie... Trudno będzie wybrać tylko jeden!
                </p>
                <p className="font-medium">
                  Połącz zasłużony odpoczynek i swoje zawodowe obowiązki w Hotel Jardín Tecina.
                </p>
                <p className="text-lg">Czekamy na Ciebie!</p>
              </div>
            </div>
          </div>
        </div>

        {/* Sala Pastrana */}
        <div className="mb-20">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <div className="w-full h-[400px] rounded-xl overflow-hidden shadow-lg">
                <img 
                  src="https://static.readdy.ai/image/2f500271175ac97b037b5e94d69334e6/9aba00d66bdf12bf401ac1c95c7dca72.jpeg"
                  alt="Sala Pastrana z eleganckim wystrojem"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="order-1 md:order-2">
              <h3 className="text-3xl font-light text-gray-800 mb-6 tracking-wide">
                SALA PASTRANA
              </h3>
              <p className="text-lg text-gray-600 mb-6 italic">
                Gdzie wyjątkowe chwile nabierają życia.
              </p>
              <div className="space-y-4 text-base text-gray-700 leading-relaxed">
                <p>
                  Witamy w Sala Pastrana! Ekskluzywna przestrzeń w Hotel Jardín Tecina, zaprojektowana tak, aby każde wydarzenie stało się niezapomnianym doświadczeniem.
                </p>
                <p>
                  Z ponad 190m² powierzchni, ta wielofunkcyjna sala łączy elegancję i technologię, aby dostosować się do każdego rodzaju spotkania lub uroczystości. Posiada scenę idealną do prezentacji lub pokazów oraz ekran o długości 15 metrów, doskonały do wydarzeń audiowizualnych. Ponadto jej sala gier dodaje rozrywkowy akcent, tworząc dynamiczną i wyjątkową atmosferę.
                </p>
                <p>
                  Czy to konferencja, czy specjalna uroczystość, w Sala Pastrana każdy detal został zaprojektowany, aby zaskoczyć.
                </p>
                <p className="text-lg font-medium text-gray-800 mt-6">
                  Twoje wydarzenie, nasza pasja.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16 pt-12 border-t border-gray-200">
          <p className="text-lg text-gray-700 mb-6">
            Chcesz dowiedzieć się więcej o naszych wydarzeniach i usługach?
          </p>
          <a
            href="https://www.jardin-tecina.com/en/weddings-events/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-black text-white px-8 py-3 rounded-full hover:bg-gray-800 transition-colors duration-300 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer"
          >
            WIĘCEJ INFORMACJI
          </a>
        </div>
      </div>
    </section>
  );
};

export default EventsWeddings;